import {createReducer, on} from '@ngrx/store';
import {
  initialVersandstatusHistoryState,
  VersandstatusHistoryState,
} from '../states/versandstatus-history.state';
import {VersandstatusHistorieBelegState} from '../states/versandstatus-historie-beleg.state';
import {VersandstatusHistoryActions} from '../actions/versandstatus-history.actions';


function emptyBelegState(): VersandstatusHistorieBelegState {
  return {
    content: [],
    totalElements: 0,
    loading: false,
  };
}


export const versandstatusHistoryReducer = createReducer(
  initialVersandstatusHistoryState,

  on(VersandstatusHistoryActions.loadVersandstatusHistorie, (state, {belegId}): VersandstatusHistoryState => {
    const existing = state.byBelegId[belegId] ?? emptyBelegState();
    return {
      ...state,
      byBelegId: {
        ...state.byBelegId,
        [belegId]: {
          ...existing,
          loading: true,
          error: undefined,
        },
      },
    };
  }),

  on(VersandstatusHistoryActions.loadVersandstatusHistorieSuccess, (state, {belegId, page}): VersandstatusHistoryState => ({
    ...state,
    byBelegId: {
      ...state.byBelegId,
      [belegId]: {
        content: page.content ?? [],
        pageable: page.pageable,
        totalElements: page.totalElements ?? 0,
        loading: false,
      },
    },
  })),

  on(VersandstatusHistoryActions.loadVersandstatusHistorieFailure, (state, {belegId, error}): VersandstatusHistoryState => {
    const existing = state.byBelegId[belegId] ?? emptyBelegState();
    return {
      ...state,
      byBelegId: {
        ...state.byBelegId,
        [belegId]: {
          ...existing,
          loading: false,
          error,
        },
      },
    };
  }),

  on(VersandstatusHistoryActions.clearVersandstatusHistorie, (state, {belegId}): VersandstatusHistoryState => {
    const {[belegId]: _removed, ...rest} = state.byBelegId;
    return {...state, byBelegId: rest};
  }),
);
